<template>
	<div>
		<form class="form-container" @submit.prevent="register">
			<input 
				:placeholder="$t('companyName')" 
				v-model="name" 
				type="text"
				maxlength="50"
				:class="{ error: $v.name.$error }"
				@blur="$v.name.$touch()"
			/>
			<template v-if="$v.name.$error">
				<p v-if="!$v.name.required" class="errorMessage">
				{{ $t('companyNameReq') }}
				</p>
			</template>
			<input 
				:placeholder="$t('vatNo')" 
				v-model="vat_no" 
				type="number"
					oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
					minLength="8"
					maxLength="8"
				class="bgOptional" 
				:class="{ error: $v.vat_no.$error }"
				@blur="$v.vat_no.$touch()"
				/>
				<template v-if="$v.vat_no.$error">
					<p v-if="!$v.vat_no.required" class="errorMessage">
					{{ $t('vatNoReq') }}
					</p>
				</template>
				<template v-if="$v.vat_no.$error">
					<p v-if="!$v.vat_no.minLength" class="errorMessage">
					{{ $t('companyVatNoLength') }}
					</p>
				</template>
				<div>
					<span class="apiKeys">{{ $t('liableForVAT') }}</span>
					<v-radio-group 
						id="liableForVAT" 
						v-model="liable_for_vat" 
						inline
						@blur="$v.liable_for_vat.$touch()"
					>
						<v-radio :label="$t('no')" value="0"></v-radio>
						<v-radio :label="$t('yes')" value="1"></v-radio>
					</v-radio-group>
				</div>


				<br/>
			<input 
				:placeholder="$t('companyAddress')" 
				v-model="address" 
				type="text"
				maxlength="30"
				:class="{ error: $v.address.$error }"
				@blur="$v.address.$touch()"
			/>
			<template v-if="$v.address.$error">
				<p v-if="!$v.address.required" class="errorMessage">
				{{ $t('addressReq') }}
				</p>
			</template>
			<input 
				:placeholder="$t('companyAddressNo')" 
				v-model="address_no" 
				type="text"
				maxlength="10"
				:class="{ error: $v.address_no.$error }"
				@blur="$v.address_no.$touch()"
			/>
			<template v-if="$v.address_no.$error">
				<p v-if="!$v.address_no.required" class="errorMessage">
				{{ $t('addressNoReq') }}
				</p>
			</template>
			<b-button
				class="help-tip"
				v-b-tooltip.hover
				:title="$t('buildingNoTooltip')"
			>?</b-button>
			<input 
				:placeholder="$t('buildingNo')" 
				v-model="building_no"
				oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
				type="number"
				maxlength="10"
				:class="{ error: $v.building_no.$error }"
				@blur="$v.building_no.$touch()"
			/>
			<template v-if="$v.building_no.$error">
				<p v-if="!$v.building_no.required" class="errorMessage">
				{{ $t('buildingNoReq') }}
				</p>
			</template>
			<input 
				:placeholder="$t('postalCode')" 
				v-model="postal_code" 
				type="text"
				maxlength="10"
				:class="{ error: $v.postal_code.$error }"
				@blur="$v.postal_code.$touch()"
			/>
			<template v-if="$v.postal_code.$error">
				<p v-if="!$v.postal_code.required" class="errorMessage">
				{{ $t('postalCodeReq') }}
				</p>
			</template>
			<b-button
				class="help-tip"
				v-b-tooltip.hover
				:title="$t('KOTooltip')"
			>?</b-button>
			<multiselect 
				:placeholder="$t('selectCity')" 
				v-model="city" 
				:options="cityNames"
				:searchable="true"
				:close-on-select="true"
				:show-labels="false"
				:class="{ error: $v.city.$error }"
				@input="changeCity()"
				@blur="$v.city.$touch()"
			/>
			<template v-if="$v.city.$error">
				<p v-if="!$v.city.required" class="errorMessage">
				{{ $t('cityReq') }}
				</p>
			</template>
			<br />

			<multiselect 
				:placeholder="$t('selectRegion')" 
				v-model="region" 
				:options="regionNames"
				:searchable="true"
				:close-on-select="true"
				:show-labels="false"
				:class="{ error: $v.region.$error }"
				@input="changeRegion()"
				@blur="$v.region.$touch()"
			/>

			<template v-if="$v.region.$error">
				<p v-if="!$v.region.required" class="errorMessage">
				{{ $t('regionReq') }}
				</p>
			</template>

			<div class="selectCountry">{{$t('selectCountry')}}</div>
			<country-select 
				v-model="country" 
				:country="country" 
				class="field inputStyle"
				topCountry="SI"
				countryName="true"
				autocomplete="true"
				removePlaceholder="true"
				usei18n="false"
				:class="field"
				@blur="$v.country.$touch()"
				/>

			<!-- <input 
				:placeholder="$t('country')" 
				v-model="country" 
				type="text" 
				:class="{ error: $v.country.$error }"
				@blur="$v.country.$touch()"
			/>
			<template v-if="$v.country.$error">
				<p v-if="!$v.country.required" class="errorMessage">
				{{ $t('countryReq') }}
				</p>
			</template> -->

			<!-- <div class="optionalData">
				<p class="optional">{{ $t('optional') }}</p>
				<input 
				:placeholder="$t('website')" 
				v-model="website_url" 
				type="url" 
				class="bgOptional"
				maxlength=50  
				name="website_url" 
				:class="{ error: $v.website_url.$error }"
				@blur="$v.website_url.$touch()"
				value />
			</div> -->
			<br/>
			<button :disabled="$v.$invalid" class="add-btn" type="submit" name="button">
					{{ $t('save') }}
			</button>
			<p v-if="$v.anyError" class="errorMessage">
				{{ $t('fillInReq') }}
			</p>
			<ul>
				<li v-for="(error, index) in errors" :key="index">{{ error }}</li>
			</ul>
		</form>			

	</div>
</template>

<script>
import NProgress from 'nprogress'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'

export default {
	data() {
		return {
			name: this.clientDetails.name,
			address_no: this.clientDetails.address_no,
			address: this.clientDetails.address,
			building_no: this.clientDetails.building_no,
			postal_code: this.clientDetails.postal_code,
			city: this.clientDetails.city,
			region: this.clientDetails.region,
			cascadian_number: null,
			cityNames: [],
			cascadianData: [],
			regionNames: [],
			country: this.clientDetails.country,
			vat_no: this.clientDetails.vat_no,
			liable_for_vat: "0",
			website_url: this.clientDetails.website_url,
			errors: null,
		}
	},
	validations: {
		name: { required },
		address_no: { required },
		address: { required },
		building_no: { required },
		postal_code: { required },
		city: { required },
		region: { required },
		country: { required },
		vat_no: { required, minLength: minLength(8), maxLength: maxLength(8) },
		liable_for_vat: { required }
	},
	async mounted() {
		this.cityNames = await this.$store.dispatch('client/fetchCascadianCityList', this.$i18n.locale)
	},
	methods: {
		register() {
			this.$v.$touch()
			if (!this.$v.$invalid) {
				NProgress.start()
				this.$store
				.dispatch('client/addClient', {
					name: this.name,
					address_no: this.address_no,
					address: this.address,
					building_no: this.building_no,
					postal_code: this.postal_code,
					city: this.city,
					region: this.region,
					cascadian_number: this.cascadian_number,
					country: this.country,
					vat_no: this.vat_no,
					liable_for_vat: this.liable_for_vat
				})
				.then(() => {
					alert(this.$t('companyDetailsSaved'))
					NProgress.done()
					this.$emit('exit', true)
				})
				.catch(err => {
					this.errors = err.response.data.errors
					NProgress.done()
				})
			}
		},
		async changeCity() {
			this.region = null
			const cityJson = {
				lang: this.$i18n.locale,
				city: this.city
			}
			this.cascadianData = await this.$store.dispatch('client/fetchCascadianRegion', cityJson)
			this.regionNames = this.cascadianData.map(a => a.municipality)
		},
			changeRegion() {
			if (this.region !== null) {
				const selectedCascadian = this.cascadianData.filter((data) => {
				return data.municipality === this.region
				})
				this.cascadian_number = selectedCascadian[0].cascadian_number
			}
		}
	},
	props: {
		clientDetails: {
		type: Object,
		required: true
		}
	}
}
</script>

<style lang="scss" scoped>

.optionalData {
	background-color: var(--grey-light);
	border: 1px solid var(--grey);
	padding: 0 20px;
	width: 100%;
}
.optional {
	text-align: center;
	letter-spacing: 5px;
	color: var(--bg);
}
.form-container {
	//position: absolute;
	background: #fff;
	padding: 30px;
	border-radius: 10px;
	box-shadow: 0px 0px 8px 0px #000;
	width: auto;
}
form .selectCountry {
	text-align: left;
	margin-bottom: 0px;
	color: #747474;
	width: 100%;
	margin-top: 10px;
	padding-left: 5px;
}

.help-tip {
  color: var(--bright) !important;
  border-radius: 50% !important;
  border: none;
  font-size: 0.8rem;
  width: min-content;
  background: var(--bg) !important;
  padding: 3px 8px !important;
  margin-right: 5px !important;
  margin-bottom: 3px !important;
}

.help-tip:hover {
  background-color: var(--primaryDark) !important;
}

.inputStyle {
	margin-bottom: 24px;
	width: 100%;
	display: block;
	height: calc(1.5em + .75rem + 2px);
	padding: .375rem .75rem;
	font-size: 1rem;
	font-weight: 400;
	line-height: 1.5;
	color: #495057;
	background-color: #fff;
	background-clip: padding-box;
	border: 1px solid #ced4da;
	border-radius: .25rem;
	transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
.field {
	margin-bottom: 24px;
}

a:visited {
	color: #2c3e50;
}

#liableForVAT {
	flex-direction: row !important;
}

.button,
button {
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 5px;
	background: linear-gradient(to right, $secondary, $secondary-dark);
	font-size: 1.5em;
	color: white;
	border: none;
	text-transform: uppercase;
	letter-spacing: 0.15em;
	outline: none;
	margin: auto;
}

button:disabled,
button[disabled]{
	border: 1px solid #999999;
	background-color: #cccccc;
	color: #666666;
	cursor: context-menu;
}

form {
	display: flex;
	text-align: left;
	flex-direction: column;

	p {
		color: red;
	}
}

input {
	display: block;
	box-sizing: border-box;
	background-clip: padding-box;
	border: 1px solid #ced4da;
	border-radius: .25rem;
	transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
	width: 100%;
	height: 2.6em;
	padding: 0.5em;
	margin-bottom: 1em;
	font: 1em 'Lato', Helvetica, sans-serif;
}

.bgOptional {
	background: rgb(252, 250, 250);
}

h1 {
	margin-top: 0;
}

.add-btn {
	background: var(--primaryDark);
	color: var(--bright);
	padding: 0.3em;
	border-radius: 5px;
	letter-spacing: 3px;
	width: 80%;
}

.errorMessage {
	font-size: 0.8em;
	margin-top: -10px;
	color: var(--primaryDark);
}

@media screen and (max-width: 560px){
.optionalData {
    padding: 10px;
	}
}
</style>
